var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/provide-contactinfo-card.html');
var config = require('./../../global/config');
var getImgParams = require('./../../global/utils').convertImgParams;
var ActionType = require('./../../constant/ActionType'); 
var dispatcher = require('./../../global/dispatcher');

var ProvideContactinfoCard = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);
};

ProvideContactinfoCard.prototype = Object.create(BaseMsgItem.prototype);
ProvideContactinfoCard.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  var content = msg.content;
  var element = this._element;
  var contactinfoContent = element.find('.im-contactinfo-card-content'); 
  var title = element.find('.im-contactinfo-title');
  var detail = element.find('.im-contactinfo-detail');
  var name;
  if (msg.sender_info.remark) {
    name = msg.sender_info.remark.remark_name || msg.sender_info.user_name || '未知';
  } else {
    name = msg.sender_info.user_name || '未知';
  }
  // title
  title.text('邀请您提供联系方式');
  //content
  var nameText = name +'邀请您提供联系方式，确保了解对方再提供，提供的信息仅对方可见，进入查看我的名片。'
  detail.text(nameText);
  contactinfoContent.click(function(e){
    e.stopPropagation();
    dispatcher.dispatch({
      type: ActionType.PROVIDE_CONTACTINFO,
      data: '联系方式邀请'
    });

  })
};

module.exports = ProvideContactinfoCard;
